module.exports = __webpack_public_path__ + "step1_child_to_parent_daughter.cda45962.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step1_child_to_parent_daughter.jpg
// module id = h6lp
// module chunks = 0